// 牌堆显示组件：抽牌堆 + 弃牌堆 + 牌数
import { useMemo } from "react";
import { useGameStore } from "@/store/gameStore";

export default function DrawPile() {
  const state = useGameStore((s) => s.state);

  const drawCount = state?.drawPile.length ?? 0;
  const discardCount = state?.discardPile.length ?? 0;

  const topDiscardName = useMemo(() => {
    if (!state || state.discardPile.length === 0) return "";
    return state.discardPile[state.discardPile.length - 1].name;
  }, [state]);

  return (
    <div className="draw-pile">
      <div className="draw-pile__slot draw-pile__slot--draw" title={`抽牌堆（${drawCount}）`}>
        <div className="draw-pile__back">
          <span className="draw-pile__emblem">命运</span>
        </div>
        <div className="draw-pile__count">{drawCount}</div>
        <div className="draw-pile__label">抽牌堆</div>
      </div>

      <div className="draw-pile__vs">VS</div>

      <div
        className="draw-pile__slot draw-pile__slot--discard"
        title={topDiscardName ? `弃牌堆顶：${topDiscardName}（共 ${discardCount}）` : `弃牌堆（${discardCount}）`}
      >
        <div className="draw-pile__front">
          {topDiscardName ? (
            <span className="draw-pile__name">{topDiscardName}</span>
          ) : (
            <span className="draw-pile__empty">空</span>
          )}
        </div>
        <div className="draw-pile__count">{discardCount}</div>
        <div className="draw-pile__label">弃牌堆</div>
      </div>
    </div>
  );
}
